var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noData"},[_c('Icon',{attrs:{"type":_vm.icon,"size":_vm.size,"color":"#dedede"}}),_c('div',{staticClass:"noDataText",style:({fontSize:_vm.fontSize})},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }